import { createContext } from 'react';
import { type PortfolioTemplates } from '../types';

const PortfolioTemplatesContext = createContext<PortfolioTemplates>(
  null as unknown as PortfolioTemplates,
);

export default PortfolioTemplatesContext;
